const BACKGROUND_COLOR = {
  YELLOW: "primary-yellow",
  GREEN: "secondary-green-700",
  LIGHTSTONE: "secondary-stone-50",
  DARKGREEN: "primary-green",
  WHITE: "white"
};

export const getBackgroundColor = (backgroundColor: string | null) => {
  switch (backgroundColor) {
    case "blue":
      return BACKGROUND_COLOR.GREEN;

    case "light grey":
      return BACKGROUND_COLOR.LIGHTSTONE;

    case "red":
      return BACKGROUND_COLOR.YELLOW;

    case "white":
      return BACKGROUND_COLOR.WHITE;

    default:
      return BACKGROUND_COLOR.DARKGREEN;
  }
};
